import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideCoreServices } from './bootstrap/provide-core';
import { provideTenant } from '@core/data/tenant/provide-tenant';
import { responseEnvelopeInterceptor } from './core/http/interceptors/response-envelope.interceptor';
import { sessionExpiryInterceptor } from './core/http/interceptors/session-expiry.interceptor';
import { traceContextInterceptor } from './core/http/interceptors/trace-context.interceptor';
import { telemetryInterceptor } from './core/http/interceptors/telemetry.interceptor';
import { authInterceptor } from '@core/http/interceptors/auth.inteceptor';
import { provideAuthInitializer } from '@core/auth/auth.initializer';
import { tenantInterceptor } from '@core/http/interceptors/tenant.interceptor';
import { httpErrorInterceptor } from '@core/http/interceptors/http-retry.interceptor';
import { provideIcons } from '../assets/icons/icon-provider';
import { ICON_MANIFEST } from '../assets/icons/icon-manifest';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        tenantInterceptor,
        httpErrorInterceptor,
        traceContextInterceptor,
        responseEnvelopeInterceptor,
        telemetryInterceptor,
        sessionExpiryInterceptor
      ]),
    ),
    provideAuthInitializer(),
    provideAnimationsAsync(),
    provideCoreServices(),
    provideTenant(),
    provideIcons(ICON_MANIFEST)
  ],
};
